import React, { FC } from 'react';

export const SuccessIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12.0002C3 16.9708 7.02944 21.0002 12 21.0002C16.9706 21.0002 21 16.9708 21 12.0002C21 7.02968 16.9706 3.00024 12 3.00024C7.02944 3.00024 3 7.02968 3 12.0002ZM14.9395 9.00024C15.2323 8.70735 15.7072 8.70735 16.0001 9.00024C16.293 9.29314 16.293 9.76801 16.0001 10.0609L11.0001 15.0609L8.00011 12.0609C7.70722 11.768 7.70722 11.2931 8.00011 11.0002C8.29301 10.7074 8.76788 10.7074 9.06078 11.0002L11.0001 12.9396L14.9395 9.00024Z"
      fill="currentColor"
    />
  </svg>
);
